// links-filter.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linkFilter',
    standalone: false
})
export class LinksFilterPipe implements PipeTransform {
    /**
     * Links in, Links out that contain all the terms in the filterText
     *
     * @param {any[]} links
     * @param {string} filterText
     * @returns {any[]}
     */
    transform(links: any[], filterText: string): any[] {
        if (!links) {
            return [];
        }
        if (!filterText) {
            return links;
        }

        return links.filter(link => {
            return this.linkContainsFilterText(link, filterText);
        });
    }

    private linkContainsFilterText(link: any, filterText): boolean {
        filterText = filterText.toLocaleLowerCase();
        const filterTerms = filterText.split(' ');
        for (const filterTerm of filterTerms) {
            const hasFilterTerm = this.linkContainsFilterTerm(link, filterTerm);
            if (hasFilterTerm === false) {
                return false;
            }
        }

        return true;
    }

    private tagsHaveFilterText(tags: string[], filterText: string): boolean {
        //call like this || this.tagsHaveFilterText(links.tags, filterTerm);
        for (const tag of tags) {
            if (tag.toLocaleLowerCase().includes(filterText)) {
                return true;
            }
        }

        return false;
    }

    private linkContainsFilterTerm(link: any, filterTerm: string) {
        //values can be null
        let sum = (link.Summary) ? link.Summary : '';
        let category = (link.Category) ? link.Category : '';
        let type = (link.Type) ? link.Type : "";
        let resourceType = (link.ResourceType) ? link.ResourceType : '';
        let tags = (link.Tags) ? link.Tags : [];


        return link.Title.toLocaleLowerCase().includes(filterTerm)
            || sum.toLocaleLowerCase().includes(filterTerm)
            || category.toLocaleLowerCase().includes(filterTerm)
            || type.toLocaleLowerCase().includes(filterTerm)
            || resourceType.toLocaleLowerCase().includes(filterTerm)
            || this.tagsHaveFilterText(tags, filterTerm);            
    }
}
